import { Card, CardContent } from '@mui/material';
import { useState } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { useNavigate, useSearchParams } from "react-router-dom";
import { LogIn, Eye, EyeOff, Info } from 'lucide-react';

export default function Login() {
const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showVerifyAlert, setShowVerifyAlert] = useState(
    () => searchParams.get('registered') === '1'
  );

  const togglePasswordVisibility = () => {
  setShowPassword(!showPassword);
};

  const handleLogin = async (e) => {
    e.preventDefault();
    const trimmedEmail = email.trim();
    const trimmedPassword = password.trim();
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!trimmedEmail) {
      toast.error('Please enter your Email');
      return;
    }

    if (!emailRegex.test(trimmedEmail)) {
      toast.error('Please enter a valid email address!');
      return;
    }
    if (!trimmedPassword) {
      toast.error('Please enter password');
      return;
    }
    if (trimmedPassword.length < 6) {
      toast.error('Password must be 6 characters!');
      return;
    }
    setError("");

    try {
      const data = { email, password };
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/users/login`, data
      );
      localStorage.setItem("authToken", response.token); 
      toast.success('Login Success!');
      setTimeout(() => {
        window.location.href = "/createbuilder";
      }, 400);
    } catch (error) {
      console.log("message", error);
      if (error.response) {
        toast.error(error.response.data.message);
      }
      else {
        toast.error("Unable to reach the server");
      }
    }
  };
const logoclick = () => {
    navigate("/home");
}
  return (
    <div
      className="h-screen bg-cover bg-center flex flex-col justify-center items-center text-white text-center px-6"
      style={{ backgroundImage: "url('/images/bg.jpg')" }}>
      <Card className="w-full max-w-[400px]" sx={{ borderRadius: '15px', paddingTop: '10px' }}>
        <div className="flex justify-center">
          <img src="/images/logo.png" alt="logo" className="max-w-[100px]"
         onClick={logoclick} style={{ cursor: 'pointer' }} />
        </div>
        <CardContent sx={{ paddingTop: '0px' }}>
          <h2 className="text-2xl font-semibold text-center text-[#000]">Login</h2>
          {showVerifyAlert && (
            <div className="mx-[10px] mt-3 mb-1 rounded-lg border border-[#49bef3] bg-[#e8f7fd] px-3 py-3 text-left relative">
              <button
                type="button"
                onClick={() => setShowVerifyAlert(false)}
                className="absolute top-1 right-2 text-[#000] text-lg leading-none"
                aria-label="Dismiss"
              >
                ×
              </button>
              <p className="text-sm text-[#000] font-semibold pr-4 flex items-start gap-2">
                <Info size={18} color="#49bef3" className="mt-[1px] shrink-0" />
                <span>Check your email to complete registration.</span>
              </p>
              <p className="text-sm text-[#333] mt-1 pr-4">
                You must verify your email address before you can log in. If you do not see the verification email in your inbox, please check your Spam or Junk folder.
              </p>
            </div>
          )}
          <form onSubmit={handleLogin} className="space-y-4 pt-5 pb-0 px-[10px]">
            <div class="relative">
              <input type="text"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder=""
                id="float_email"  className="block w-full text-sm text-gray-900 bg-transparent rounded-lg border border-[#49bef3] appearance-none dark:border-[#49bef3] focus:outline-none focus:ring-0 focus:border-blue-600 peer dark:focus:border-blue-500" />
              <label for="float_email"  className="absolute text-sm text-[#49bef3] dark:text-[#49bef3] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2
      peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-600
      peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2
      peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75
      peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Email</label>
            </div>
            <div class="relative">
              <input type={showPassword ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder=""
                id="float_password" className="block w-full text-sm text-gray-900 bg-transparent rounded-lg border border-[#49bef3] appearance-none dark:border-[#49bef3] focus:outline-none focus:ring-0 focus:border-blue-600 peer dark:focus:border-blue-500"  />
              <label for="float_password" className="absolute text-sm text-[#49bef3] dark:text-[#49bef3] duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white px-2
      peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-600
      peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2
      peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75
      peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">Password</label>

      <div
    className="absolute inset-y-0 right-2 flex items-center cursor-pointer"
    onClick={togglePasswordVisibility}
  >
    {showPassword ? <Eye size={18} color='#49bef3' /> : <EyeOff size={18} color='#49bef3' />}
  </div>

            </div>
            
          <div className="text-right text-base mb-2">
                <a href="/forgotpassword" className="text-blue-500 hover:underline">
                  Forgot Password?
                </a>
              </div>

             <button
  type="submit"
  className="w-[150px] flex gap-1 items-center bg-[#49bef3] hover:bg-blue-700 text-white py-[6px] px-6 rounded-[50px] text-base border-2 border-blue-500 justify-center m-auto"
>
  <LogIn size={25} />
  Login
</button>

             
      

          </form>
          <p className="mt-4 text-center text-base">
            Don't have an account?{' '}
            <a href="/register" className="text-blue-500 hover:underline">
              Register
            </a>
          </p>
        </CardContent>
      </Card>
      <ToastContainer />

    </div>
  );
}